const initialState = {
  uploadError: '',
  loading: false,
  documents: {},
};

const scraper = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SCRAPE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SCRAPE_SUCCESS':
      return {
        ...state,
        loading: false,
        documents: payload.documents,
        uploadError: '',
      };
    case 'SCRAPE_FAILURE':
      return {
        ...state,
        documents: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default scraper;



// WEBPACK FOOTER //
// ./client/app/reducers/scraper.js